import {
  Inline,
  Stack,
  Tag,
  type TagIntent,
} from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import { ExpenseStatusEnum } from '@omnipresentgroup/types';

type ExpenseStatusProps = {
  status: ExpenseStatusEnum;
};

const getStatusStyle = (status: ExpenseStatusEnum): TagIntent => {
  const styles: Record<ExpenseStatusEnum, TagIntent> = {
    [ExpenseStatusEnum.PAID]: 'success',
    [ExpenseStatusEnum.PROCESSED]: 'success',
    [ExpenseStatusEnum.APPROVED]: 'info',
    [ExpenseStatusEnum.PENDING]: 'warning',
    [ExpenseStatusEnum.INFO_NEEDED]: 'warning',
    [ExpenseStatusEnum.CHANGE_MADE]: 'info',
    [ExpenseStatusEnum.REJECTED]: 'error',
  };

  return styles[status] || 'default';
};

export const ExpenseStatus = ({ status }: ExpenseStatusProps) => {
  const intent = getStatusStyle(status);
  const pendingIntent = getStatusStyle(ExpenseStatusEnum.PENDING);

  const renderTag = (id: string, tagIntent: TagIntent, label: string) => (
    <Stack>
      <Tag id={id} intent={tagIntent}>
        {toSentenceCase(label)}
      </Tag>
    </Stack>
  );

  if (
    status === ExpenseStatusEnum.CHANGE_MADE ||
    status === ExpenseStatusEnum.INFO_NEEDED
  ) {
    return (
      <Inline css={{ flexWrap: 'wrap' }}>
        {renderTag('pending-status', pendingIntent, ExpenseStatusEnum.PENDING)}
        {renderTag(status, intent, status)}
      </Inline>
    );
  }

  return renderTag(status, intent, status);
};
